import serviceOrdersService from '../services/serviceOrders.service';

export const serviceOrdersIndicator = {
  namespaced: true,
  state: {
    showSidebar: false,
    lgSemPat: 0,
    lgPorAceitar: 0,
    hisenseSemPat: 0,
    hisensePorAceitar: 0,
    dgSemPat: 0,
    dgPorAceitar: 0,
  },
  getters: {
    showSidebar: state => state.showSidebar,
    lgSemPat: state => state.lgSemPat,
    lgPorAceitar: state => state.lgPorAceitar,
    hisenseSemPat: state => state.hisenseSemPat,
    hisensePorAceitar: state => state.hisensePorAceitar,
    dgSemPat: state => state.dgSemPat,
    dgPorAceitar: state => state.dgPorAceitar,
    totalPending: state =>
      state.lgSemPat + state.lgPorAceitar +
      state.hisenseSemPat + state.hisensePorAceitar +
      state.dgSemPat + state.dgPorAceitar,
  },
  actions: {
    async fetchCounts({ commit }) {
      try {
        const [
          lgSemPat,
          lgPorAceitar,
          hisenseSemPat,
          hisensePorAceitar,
          dgSemPat,
        ] = await Promise.all([
          serviceOrdersService.countLgServiceOrdersWithoutPat(),
          serviceOrdersService.countLgServiceOrdersToAccept(),
          serviceOrdersService.countHisenseServiceOrdersWithoutPat(),
          serviceOrdersService.countHisenseServiceOrdersForAccepted(),
          serviceOrdersService.countDgServiceOrdersWithoutPat(),
        ]);
        commit('setCounts', {
          lgSemPat,
          lgPorAceitar,
          hisenseSemPat,
          hisensePorAceitar,
          dgSemPat,
          dgPorAceitar: 0,
        });
      } catch (error) {
        // ignore silently
      }
    },
    toggleSidebar({ commit }, show) {
      commit('setShowSidebar', show);
    },
  },
  mutations: {
    setCounts(state, {
      lgSemPat,
      lgPorAceitar,
      hisenseSemPat,
      hisensePorAceitar,
      dgSemPat,
      dgPorAceitar,
    }) {
      state.lgSemPat = lgSemPat;
      state.lgPorAceitar = lgPorAceitar;
      state.hisenseSemPat = hisenseSemPat;
      state.hisensePorAceitar = hisensePorAceitar;
      state.dgSemPat = dgSemPat;
      state.dgPorAceitar = dgPorAceitar;
    },
    setShowSidebar(state, show) {
      state.showSidebar = show;
    },
  },
};
